// src/components/WhatsAppIcon.js
import React from "react";
import "./style.css"; // We'll create this CSS file next
import WhatsAppLogo from "../../assets/logo-whatsapp-png-46041.png";

const WhatsAppIcon = () => {
  // Get phone number from environment variable or use default
  const phoneNumber = process.env.REACT_APP_PHONE_NUMBER
    ? process.env.REACT_APP_PHONE_NUMBER.replace(/\s/g, "")
    : "94771781833";

  const defaultMessage =
    process.env.REACT_APP_WHATSAPP_DEFAULT_MESSAGE ||
    "Good day, I came across your profile and would like to discuss a potential collaboration opportunity. Could we connect at your earliest convenience?";

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;

  return (
    <div className="whatsapp-icon">
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        title="Chat on WhatsApp"
      >
        <img
          width="48"
          height="48"
          src={WhatsAppLogo}
          alt="WhatsApp Chat"
          loading="lazy"
        />
      </a>
    </div>
  );
};

export default WhatsAppIcon;
